import {
  MissionControlCollapseRoutes,
  MissionControlHeader,
  MissionControlRoutes,
  PowerToolsRoutes,
  SupportalHeader,
  SupportalRoutes,
} from "./SupportalRoutes";
import Constants from "../../utils/Constants";

export const CRMRoutes = (tenantID: string | undefined) => {
  const isMissionControl = tenantID === Constants.MC_CLOUD_ID;
  const isSupportal = tenantID === Constants.SUP_CLOUD_ID;

  let baseLinks: Routes = {
    title: { name: "CRM", icon: "mdi mdi-account-convert", color: "dark" },
    items: isMissionControl
      ? [
          { type: "SidebarHeader" },
          ...MissionControlHeader,
          ...MissionControlCollapseRoutes(`/clouds/${tenantID}/mc`),
          ...MissionControlRoutes(`/clouds/${tenantID}/mc`),
          ...PowerToolsRoutes(`/clouds/${tenantID}/mc`),
          { type: "SidebarAdd" },
          { type: "CRMCustomLinks" },
        ]
      : isSupportal
      ? [
          {
            type: "SidebarHeader",
          },
          ...SupportalHeader,
          ...SupportalRoutes(`/clouds/${Constants.SUP_CLOUD_ID}/supportal`)
            .items,
          { type: "SidebarAdd" },
          { type: "CRMCustomLinks" },
        ]
      : [
          {
            type: "SidebarHeader",
          },
          {
            type: "CustomLink",
            name: "Brie AI Tools",
            icon: "brie-icon",
            path: "brie/home",
          },
          {
            type: "CustomLink",
            name: "Growth Drive",
            icon: "mdi mdi-folder-table",
            path: "gc-drive",
          },
          { type: "OptionList", option: "QuickActivity" },
          { type: "SidebarAdd" },
          { type: "CRMCustomLinks" },
        ],
  };

  return baseLinks;
};

interface Routes {
  title: { name: string; icon: string; color: string };
  items: {
    type: string;
    option?: string;
    name?: string;
    icon?: string;
    path?: string;
  }[];
}
